import { AdminFormFieldsNames, TAdminFormValues } from '../helpers/types';
import { AdminRoles, AdminStatus, IUpdateAdminDTO } from '@/models/admins.model';

class AdminProfileDTO implements IUpdateAdminDTO {
  id?: string;
  role?: AdminRoles;
  status?: AdminStatus;
  full_name?: string;
  email?: string;
  phone_number?: string;

  constructor(values: TAdminFormValues, id?: string | null) {
    if (id) {
      this.id = id;
    }

    this.email = values[AdminFormFieldsNames.EMAIL];
    this.role = values[AdminFormFieldsNames.ROLE];
    this.status = values[AdminFormFieldsNames.STATUS];
    this.full_name = values[AdminFormFieldsNames.NAME];
    this.phone_number = values[AdminFormFieldsNames.PHONE_NUMBER];
  }
}

export default AdminProfileDTO;
